<template>
  <div>
    <vs-popup
      :title="`گزارش فروش ${
        salesPersonData ? salesPersonData.fullNameOfSalePerson : ''
      }`"
      :active.sync="showModal"
    >
      <div v-show="dataLoading">
        <div id="loading-grid">
          <svg
            class="spinner"
            width="65px"
            height="65px"
            viewBox="0 0 66 66"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              class="path"
              fill="none"
              stroke-width="6"
              stroke-linecap="round"
              cx="33"
              cy="33"
              r="30"
            ></circle>
          </svg>
        </div>
      </div>
      <div v-if="showModal && !dataLoading" class="w-full overflow-x-hidden">
        <div
          class="flex w-full h-full gap-4 justify-center items-center flex-col py-4"
        >
          <div class="flex w-full items-start">
            <div class="flex flex-col justify-evenly w-1/2 items-center h-full">
              <span class="font-bold text-lg text-center">
                میزان فروش بر اساس سگمنت‌ها</span
              >
              <vue-apex-charts
                class=""
                type="pie"
                height="200"
                :options="chartOptions"
                :series="series"
              />
              <div
                class="grid grid-cols-2 gap-x-3 gap-y-1 items-center px-2"
                style="direction: ltr"
              >
                <div
                  class="cursor-default"
                  v-for="item of chartLegends"
                  :key="item.hexColor"
                >
                  <vx-tooltip
                    :title="item.label"
                    position="top"
                    :color="item.hexColor"
                  >
                    <div class="flex gap-2 items-end">
                      <div
                        class="w-6 h-6 rounded-full flex-shrink-0"
                        :style="{ backgroundColor: item.hexColor }"
                      ></div>
                      <span class="text-sm">{{ item.label }}</span>
                    </div>
                    <template slot="content">
                      <div
                        style="direction: ltr"
                        class="flex text-center w-full justify-center flex-col font-bold"
                      >
                        <div>
                          <span>{{ item.value.toLocaleString() }}</span>
                        </div>
                        <span
                          >{{
                            salesPersonData.amountOfOrders
                              ? Number(
                                  (
                                    (item.value /
                                      salesPersonData.amountOfOrders) *
                                    100
                                  ).toFixed(2)
                                )
                              : 0
                          }}%</span
                        >
                      </div>
                    </template>
                  </vx-tooltip>
                </div>
              </div>
            </div>
            <div class="flex flex-col w-1/2 items-center justify-start gap-2">
              <span class="font-bold text-lg text-center">
                نسبت فروش به کل تارگت</span
              >

              <vue-apex-charts
                style="margin-top: -30px; margin-bottom: -30px"
                type="radialBar"
                :series="[
                  [
                    salesPersonData.totalAmountOfSegmentAgentTarget
                      ? (
                          (salesPersonData.amountOfOrders /
                            salesPersonData.totalAmountOfSegmentAgentTarget) *
                          100
                        ).toFixed(2)
                      : 0,
                  ],
                ]"
                height="260"
                :options="gaugeOptions"
              ></vue-apex-charts>
              <div class="flex flex-col">
                <span
                  >تارگت کل:
                  {{
                    Math.round(
                      salesPersonData.totalAmountOfSegmentAgentTarget
                    ).toLocaleString()
                  }}</span
                >
                <span
                  >میزان فروش:
                  {{
                    Math.round(salesPersonData.amountOfOrders).toLocaleString()
                  }}</span
                >
              </div>
            </div>
          </div>
          <hr class="w-full" />
          <span class="font-bold text-lg text-center"
            >میزان فروش سگمنت‌ها بر اساس تارگت</span
          >
          <div class="flex justify-center w-full flex-wrap gap-y-4">
            <div
              class="w-1/2 flex justify-center flex-col gap-2"
              v-for="chart of segmentTargetsCharts"
              :key="chart.name"
            >
              <span class="font-bold text-lg text-center">{{
                chart.name
              }}</span>
              <vue-apex-charts
                type="pie"
                height="200"
                :options="segmentTargetsChartOptions"
                :series="chart.series"
              />
              <span class="text-center"
                >تارگت: {{ chart.additionalData.toLocaleString() }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    show: { default: false },
    salesPersonData: { type: Object, requierd: true },
    dataLoading: { type: Boolean },
  },
  data() {
    return {
      series: [],
      chartLegends: [],
      chartOptions: {
        labels: [],
        tooltip: {
          y: {
            formatter: function (val) {
              return Number(val).toLocaleString();
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: { show: false },
        chart: {
          fontFamily: "IRANSans",
          type: "donut",
          dropShadow: {
            enabled: false,
            blur: 5,
            left: 1,
            top: 1,
            opacity: 0.2,
          },
          toolbar: {
            show: false,
          },
        },
        stroke: {
          width: 0.5,
        },
        colors: [],
        fill: {},
      },
      gaugeOptions: {
        chart: {
          height: 260,
          type: "radialBar",
          fontFamily: "IRANSans",
        },
        plotOptions: {
          radialBar: {
            startAngle: -135,
            endAngle: 135,
            track: {
              strokeWidth: "97%",
              margin: 5, // margin is in pixels
              dropShadow: {
                enabled: true,
                top: 0,
                left: 0,
                color: "#999",
                opacity: 0.5,
                blur: 2,
              },
            },
            dataLabels: {
              name: {
                show: false,
                fontSize: "16px",
                color: undefined,
                offsetY: 120,
              },
              value: {
                offsetY: 76,
                fontSize: "22px",
                color: undefined,
                formatter: function (val) {
                  return val + "%";
                },
              },
            },
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            shadeIntensity: 0.4,
            inverseColors: false,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 50, 53, 91],
          },
        },
      },
      segmentTargetsCharts: [],
      segmentTargetsChartOptions: {
        labels: ["میزان فروش", "مانده تارگت"],
        tooltip: {
          y: {
            formatter: function (val) {
              return Number(val).toLocaleString();
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: { show: false },
        chart: {
          fontFamily: "IRANSans",
          type: "donut",
          dropShadow: {
            enabled: false,
            blur: 5,
            left: 1,
            top: 1,
            opacity: 0.2,
          },
          toolbar: {
            show: false,
          },
        },
        stroke: {
          width: 0.5,
        },
        colors: ["#00ad40", "#ff4242"],
        fill: {},
      },
    };
  },
  computed: {
    ...mapGetters({
      segmentsColors: "theme/segmentsColors",
    }),
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({}),
    getSegmentColor(segmentId) {
      const theSegment = this.segmentsColors.find(
        (segment) => segment.id == segmentId
      );
      if (theSegment) {
        return theSegment.color;
      }
      return "#bababa";
    },
    getRandomColor() {
      return (
        "#" + ((Math.random() * 0xffffff) << 0).toString(16).padStart(6, "0")
      );
    },
    setOrdersAndTargetPerSegmentChartsData() {
      this.salesPersonData.ordersPerSegmentsOfSalePerson.forEach((segment) => {
        if (segment.segmentTargetAmountForSalePerson > 0) {
          let datasets = [];
          datasets.push(segment.amount);
          datasets.push(
            segment.segmentTargetAmountForSalePerson - segment.amount
          );
          this.segmentTargetsCharts.push({
            series: datasets,
            name: segment.segmentName,
            additionalData: segment.segmentTargetAmountForSalePerson,
          });
        }
      });
    },
    setOrdersPerSegmentChartData() {
      let lables = [];
      let datasets = [];
      let noData = true;
      this.salesPersonData.ordersPerSegmentsOfSalePerson.forEach((segment) => {
        lables.push(segment.segmentName);
        datasets.push(segment.amount);
        if (segment.amount > 0) {
          noData = false;
          const segmentColor = this.getSegmentColor(segment.segmentId);
          this.chartOptions.colors.push(segmentColor);
          this.chartLegends.push({
            hexColor: segmentColor,
            label: segment.segmentName,
            value: segment.amount,
          });
        }
      });
      if (noData) {
        this.chartOptions.labels = [];
        this.series = [1];
        this.chartOptions.colors = [];
        (this.chartOptions.tooltip = {
          custom: function () {
            return `
                    <div class="arrow_box flex flex-col justify-center gap-2">
                        <span class="apexcharts-tooltip-title px-2 flex items-center justify-center bg-grey">
                        این متصدی، هنوز فروشی انجام نداده
                        </span>
                    </div>
                    `;
          },
        }),
          this.chartOptions.colors.push("#f0f0f0");
      } else {
        this.chartOptions.labels = lables;
        this.series = datasets;
      }
    },
    resetChart() {
      this.series = [];
      this.chartLegends = [];
      this.chartOptions.colors = [];
      this.segmentTargetsCharts = [];
      this.chartOptions.tooltip = {
        y: {
          formatter: function (val) {
            return Number(val).toLocaleString();
          },
        },
      };
    },
  },
  watch: {
    show() {
      if (this.show && !this.dataLoading) {
        this.setOrdersPerSegmentChartData();
        this.setOrdersAndTargetPerSegmentChartsData();
      } else {
        this.resetChart();
      }
    },
    dataLoading() {
      if (!this.dataLoading && this.show) {
        this.setOrdersPerSegmentChartData();
        this.setOrdersAndTargetPerSegmentChartsData();
      } else {
        this.resetChart();
      }
    },
  },
  components: {
    VueApexCharts,
  },
};
</script>
